export const preset = "default" as const;
export const siteName = "⚡ Landrr.js";

const GITHUB_URL = "https://github.com/valtterisa/landrr.js";
const NPM_CORE_URL = "https://www.npmjs.com/package/@landrr/core";
const NPM_CLI_URL = "https://www.npmjs.com/package/create-landrr-app";

export const pages = {
  home: [
    {
      block: "navbar",
      siteName,
      homeHref: "/",
      className: "sticky top-0 z-50",
      links: [
        { label: "Features", href: "#features" },
        { label: "Use cases", href: "#use-cases" },
        { label: "Quick start", href: "#quick-start" },
        { label: "Docs", href: "https://valtterisa.github.io/landrr.js/docs/" },
        { label: "GitHub", href: GITHUB_URL },
        { label: "npm", href: NPM_CORE_URL },
      ],
    },
    {
      block: "hero",
      title: "Fast, SEO-ready client sites",
      subtitle:
        "A modern React framework with Vite, SSR, and SSG. Ship landing pages, docs, and client sites — render on the server or pre-build static HTML at deploy time.",
      ctaText: "Get started",
      ctaHref: "#quick-start",
    },
    {
      block: "featureGrid",
      id: "features",
      className: "scroll-mt-16",
      heading: "Why Landrr?",
      items: [
        {
          title: "Vite",
          description: "Instant dev server, HMR, and tiny production bundles.",
        },
        {
          title: "React 18",
          description: "Hooks, Suspense, and concurrent rendering built in.",
        },
        {
          title: "SSR",
          description: "Server-render pages on each request for dynamic data and SEO.",
        },
        {
          title: "SSG",
          description:
            "Pre-render routes at build time. Deploy static HTML to GitHub Pages with no server.",
        },
        {
          title: "TypeScript",
          description: "Typed from day one across your entire app.",
        },
        {
          title: "SEO",
          description: "Head component and meta helpers included.",
        },
      ],
    },
    {
      block: "featureGrid",
      id: "use-cases",
      className: "scroll-mt-16",
      heading: "What you can build",
      items: [
        {
          title: "Marketing sites",
          description: "Landing pages, product sites, and launch pages with blocks and SSG.",
        },
        {
          title: "Documentation",
          description: "Multi-page docs with routing, search-friendly HTML, and fast loads.",
        },
        {
          title: "Portfolios & blogs",
          description: "Static-first sites that hydrate into interactive React apps.",
        },
        {
          title: "Client dashboards",
          description: "SSR when you need live data; SSG when content is mostly static.",
        },
        {
          title: "GitHub Pages",
          description: "Export static HTML and assets — no Node server required.",
        },
        {
          title: "Node hosting",
          description: "Run server.js on Vercel, Railway, or any Node host for full SSR.",
        },
      ],
    },
    { block: "quickStart" },
    {
      block: "cta",
      title: "Ready to build?",
      buttonText: "View on GitHub",
      buttonHref: GITHUB_URL,
    },
    {
      block: "footer",
      copyright: "© 2026 Landrr.js. MIT License.",
      links: [
        { label: "GitHub", href: GITHUB_URL },
        { label: "@landrr/core", href: NPM_CORE_URL },
        { label: "create-landrr-app", href: NPM_CLI_URL },
      ],
    },
  ],
} as const;
